import React, {useState, useEffect, useRef, useContext} from 'react';
import styles from './SwapMain.module.css';
import MyAssetsCards from "./MyAssetsCards/MyAssetsCards";
import usdiImg from "./static_files/U.svg";

import approxImg from "./static_files/Text.svg";
import {fetchPortfolioTrackRecordsRoundFourDigit} from "./linechart/fetchDailyPortfolioData";
import TransactionDetailModal from "./transaction_detail/TransactionDetail";
import TransactionDetailLargeAmount from "./transaction_detail/TransactionDetailLargeAmount";

import copyConfirmMobileImg from './static_files/copyConfirmMobile.png'

import {useNavigate} from 'react-router-dom';
import copyInnerImg from "./static_files/copy inner.svg";
import shareInnerImg from "./static_files/share inner.svg";
import copyInnerHoverImg from "./static_files/copy inner hover.svg";
import shareInnerHoverImg from "./static_files/share inner hover.svg";
import VenmoIcon from './static_files/Venmo.svg';
import ZelleIcon from './static_files/Zelle.svg';
import AlipayIcon from './static_files/Alipay.svg';
import WireIcon from './static_files/Wire.svg';
import USDIcon from './static_files/usd.svg';


import ConnectWalletHeader from "./header/ConnectWalletHeader";
import LeftPanel from "./SwapLeftPanel/LeftPanel";
import {SwapMainAppContext} from "../SwapMainAppContext";

import {motion, LayoutGroup} from 'framer-motion';
import {shortenAddress, parseAmountLimit} from './utils'


import {USDI_API_URL, ENDPOINT_BASE_URL, LARGE_AMOUNT} from '../configs/config';
import MintTab from "./MintTab/MintTab";
import RedeemTab from "./RedeemTab/RedeemTab";
import Tooltip from "./Tooltip/Tooltip"
import TooltipBottom from "./Tooltip/TooltipBottom";

const SwapMainAPP = () => {
    const navigate = useNavigate();
    // Email logged in user data
    const [usdiValue, setUsdiValue] = useState(null);
    // its for Solana USDI holder info table 获取与当前用户的data
    const [usdiHoldersData, setUsdiHoldersData] = useState();
    const [availableUSDI, setAvailableUSDI] = useState(null);
    const [cumulativeInterest, SetCumulativeInterest] = useState(0);
    const [accruedInterest, setAccruedInterest] = useState(0)
    const [holderDataLoading, setHolderDataLoading] = useState(true)
    const [ImpliedApy, setImpliedApr] = useState(0);
    const [displayedApy, setDisplayedApy] = useState("Implied APY");
    const [displayedAPYTooltip, setDisplayedAPYTooltip] = useState("");

    const [selectedTab, setSelectedTab] = useState('mint'); // "mint" | "redeem"
    const [txTrigger, setTxTrigger] = useState(0);

    // 在connect wallet header 连接钱包后的pub key在这
    const [usdtBalance, setUsdtBalance] = useState(0);
    const [usdcBalance, setUsdcBalance] = useState(0);
    const [usdiBalance, setUsdiBalance] = useState("--");
    const [userClass, setUserClass] = useState('General Member')
    // use to open connect wallet side panel
    const [showPanel, setShowPanel] = useState(false);

    // Which token is selected ("USDC" or "USDT" or "CASH" from redeem)
    const [selectedToken, setSelectedToken] = useState("USDC");

    // Show/hide token selector modal
    const [showTokenSelector, setShowTokenSelector] = useState(false);
    const methodItemRef = useRef(null);
    const tokenSelectorRef = useRef(null); // for clicking somewhere else to close it

    // Single input for both Mint and Redeem tabs
    const [typedMintValue, setTypedMintValue] = useState("0");

    // Final "confirmed" amount to pass to ConnectWalletHeader
    const [confirmedAmount, setConfirmedAmount] = useState("0");
    const [justCopiedUSDC, setJustCopiedUSDC] = useState(false);
    const [justCopiedUSDT, setJustCopiedUSDT] = useState(false);

    // Font-size + container ref + hidden measuring span + input ref
    const [dynamicFontSize, setDynamicFontSize] = useState(88);
    const containerRef = useRef(null);
    const spanRef = useRef(null);
    const inputRef = useRef(null);

    const MIN_FONT_SIZE = 20;
    const MAX_FONT_SIZE = 88;
    const [isWalletLoading, setIsWalletLoading] = useState(true);

    const {
        notification, showNotification, networkFeePercent,
        usdtTokenAddress,
        usdcTokenAddress,
        usdiTokenAddress,
        squadsPublicKey,
        walletAddress,
        setWalletAddress,
    } = useContext(SwapMainAppContext);

    // for transaction detail page -> after cash redeem , show modal let user confirm
    const [showTransactionDetailModal, setShowTransactionDetailModal] = useState(false);
    const [transactionDetailConfirmed, setTransactionDetailConfirmed] = useState(false);
    const [transactionDetailTxsID, setTransactionDetailTxsID] = useState(null);

    const [redeemValueForModal, setRedeemValueForModal] = useState(0);
    const [localTimeTransaction, setLocalTimeTransaction] = useState(null);
    const [UTCTimeTransaction, setUTCTimeTransaction] = useState(null);

    // large amount modal
    const [showTransactionDetailLargeModal, setShowTransactionDetailLargeModal] = useState(false);
    const [largeAmountValueForModal, setLargeAmountValueForModal] = useState(0);
    const [largeAmountConfirmed, setLargeAmountConfirmed] = useState(false);

    // Watch for squads proposal creation success to flip modal UI
    useEffect(() => {
        if (notification?.status === 'success' &&
            typeof notification?.message === 'string' &&
            notification.message.toLowerCase().includes('squads proposal successfully created')) {
            setLargeAmountConfirmed(true);
        }
    }, [notification]);

    // 新增payment method 3
    const methodItemRef3 = useRef(null);
    const [paymentInfoData, setPaymentInfoData] = useState([]);
    // 这是用户在第二个下拉里选中的那一条
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
    const [showAddPayment, setShowAddPayment] = useState(false);

    // 用来控制“第二个下拉(Transfer to)”的展开/收起
    const [showTokenSelector3, setShowTokenSelector3] = useState(false);
    const tokenSelectorRef3 = useRef(null);

    const [refetchPaymentMethods, setRefetchPaymentMethods] = useState(0);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const [walletUserEmail, setWalletUserEmail] = useState(null);
    const [availablePaymentMethods, setAvailablePaymentMethods] = useState([]);

    const iconMap = {
        'Bank Wire': WireIcon,
        'Physical Cash': USDIcon,
        'Zelle': ZelleIcon,
        'Venmo': VenmoIcon,
        'Alipay': AlipayIcon,
    };

    function getPaymentInfoDisplay(item) {
        switch (item.payment_method) {
            case 'Zelle':
                return item.email || item.mobile_number || 'No info';
            case 'Venmo':
                return item.account_number || 'No account number';
            case 'Alipay':
            case 'Physical Cash':
                return item.mobile_number || 'No mobile';
            case 'Bank Wire':
                return item.account_number || 'No account';
            default:
                return 'No data';
        }
    }

    const c2cRedeemTransferComplete = (txsId) => {
        setTransactionDetailConfirmed(true);
        setTransactionDetailTxsID(txsId)
    };
    // 切换第二个下拉
    const handleMethodItemClick3 = (e) => {
        e.stopPropagation();
        setShowTokenSelector3(prev => !prev);
    };

    // 用户选中某条 payment
    const handleSelectPaymentMethod = (info) => {
        setSelectedPaymentMethod(info);
        setShowTokenSelector3(false);
    };

    useEffect(() => {
        if (showTokenSelector) {
            setShowTokenSelector3(false);
        }
    }, [showTokenSelector]);

    useEffect(() => {
        if (showTokenSelector3) {
            setShowTokenSelector(false);
        }
    }, [showTokenSelector3]);

    // ------------------------ Referral Code Store in local ------------------------
    useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const referralCode = searchParams.get('ref');

    if (referralCode) {
      localStorage.setItem('referralCode', referralCode);
    }
  }, []);
    // ------------------------ FETCH DATA  ------------------------
    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await Promise.any([
                    fetchPortfolioTrackRecordsRoundFourDigit().catch(e => null),
                ]);
                if (data) {
                    // Filter out null/NaN values before calculating max
                    const apyValues = [
                        { value: data.impliedApr, type: 'implied' },
                        { value: data.ninetyDayApy, type: 'ninety' },
                        { value: data.thirtyDayApy, type: 'thirty' }
                    ].filter(item => item.value != null && !isNaN(item.value));

                    let maxApy;
                    let maxApyType = "";
                    let tooltip = "";

                    if (apyValues.length > 0) {
                        // Find the maximum value
                        const maxItem = apyValues.reduce((max, item) => 
                            item.value > max.value ? item : max
                        );
                        maxApy = maxItem.value;

                        // Determine the type based on which value was the max
                        if (maxApy === data.impliedApr) {
                            maxApyType = "Implied APY";
                            tooltip = <>The estimated annual <br/> percentage yield based<br/> on current rates</>;
                        } else if (maxApy === data.ninetyDayApy) {
                            maxApyType = "90-Day APY";
                            tooltip = <>The annual percentage yield<br/> calculated based on the past<br/> 90 days' performance</>;
                        } else if (maxApy === data.thirtyDayApy) {
                            maxApyType = "30-Day APY";
                            tooltip = <>The annual percentage yield<br/> calculated based on the past<br/> 30 days' performance</>;
                        }
                    } else {
                        // Fallback if all values are null/NaN
                        maxApy = 0;
                        maxApyType = "Implied APY";
                        tooltip = <>The estimated annual <br/> percentage yield based<br/> on current rates</>;
                    }

                    setUsdiValue(data.totalValue / data.usdiInCirculation);
                    setImpliedApr(maxApy);
                    setDisplayedApy(maxApyType)
                    setDisplayedAPYTooltip(tooltip);
                } else {
                    console.error("Failed to fetch one or more data endpoints");
                }

                if (!walletAddress) {
                    setWalletUserEmail("--");
                    setUsdiHoldersData([]);
                    setHolderDataLoading(false);
                    return;
                }
                setHolderDataLoading(true);
                const response = await fetch(`${USDI_API_URL}/usdi_holders_info_table_solana?address=${walletAddress}`);
                if (!response.ok) throw new Error('Network response was not ok');
                const result = await response.json();

                if (result && result[0] && result[0].user_class) {
                    setUserClass(result[0].user_class)
                    localStorage.setItem('userClass', result[0].user_class);
                    // if its vip, set default to CASH
                    if (result[0].user_class.split(" ")[1] === "VIP") {
                        setSelectedToken("CASH")
                    }
                }
                setUsdiHoldersData(result);
                if (result && result[0]) {
                    setWalletUserEmail(result[0].email)
                } else {
                    setWalletUserEmail("--")
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, [walletAddress]);


    // 1) 在 RedeemTab 内部自己 fetchPaymentInfo
    useEffect(() => {
        const fetchPaymentInfo = async () => {
            if (!walletAddress) {
                setPaymentInfoData([]);
                return;
            }
            try {
                let paramKey, paraValue;
                let extraParam = ""; // Will hold the extra parameter when using wallet login


                paramKey = "wallet_address";
                paraValue = walletAddress;
                extraParam = "&email_user_wallet_chain=solana_receive_address";

                const url = `${ENDPOINT_BASE_URL}/get_payment_info?${paramKey}=${paraValue}${extraParam}`;
                const res = await fetch(url);

                if (!res.ok) {
                    console.error(`Error fetching payment info: ${res.status} ${res.statusText}`);
                    setPaymentInfoData([]);
                    return;
                }

                const jsonData = await res.json();
                if (!jsonData.success) {
                    console.error("API returned success=false:", jsonData);
                    setPaymentInfoData([]);
                    return;
                }

                const arr = jsonData.data || [];
                setPaymentInfoData(arr);

                // 若有 default_payment === true
                const defaultRow = arr.find(item => item.default_payment === true);
                if (defaultRow) {
                    setSelectedPaymentMethod(defaultRow);
                }
            } catch (err) {
                console.error("Error fetching payment info:", err);
                setPaymentInfoData([]);
            }
        };

        fetchPaymentInfo();
    }, [walletAddress, refetchPaymentMethods]);


    // 找用户的cum_distributed_usdi 和 Accrued Interest
    useEffect(() => {
        if (usdiHoldersData && usdiHoldersData[0]) {
            const cumulative = parseFloat(usdiHoldersData[0].cum_distributed_usdi) || 0;
            const accrued = parseFloat(usdiHoldersData[0].accrued_interest) || 0;
            SetCumulativeInterest(cumulative);
            setAccruedInterest(accrued);
            console.log("My Assets - Cumulative Interest:", cumulative, "Accrued Interest:", accrued);
            setHolderDataLoading(false)
        } else {
            SetCumulativeInterest(0);
            setAccruedInterest(0)
            setHolderDataLoading(false)
        }
    }, [usdiHoldersData]);


    useEffect(() => {
        function handleClickOutside(e) {
            if (!showTokenSelector) return;
            if (
                methodItemRef.current?.contains(e.target) ||
                tokenSelectorRef.current?.contains(e.target)
            ) {
                return;
            }
            setShowTokenSelector(false);
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showTokenSelector]);
    useEffect(() => {
        function handleClickOutside3(e) {
            if (!showTokenSelector3) return;
            if (
                methodItemRef3.current?.contains(e.target) ||
                tokenSelectorRef3.current?.contains(e.target)
            ) {
                return;
            }
            setShowTokenSelector3(false);
        }

        document.addEventListener('mousedown', handleClickOutside3);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside3);
        };
    }, [showTokenSelector3]);

    // ------------------------ MINT & REDEEM ------------------------
    const handleMintUSDi = () => {
        const mintValueAsNumber = parseFloat(typedMintValue);
        if (isNaN(mintValueAsNumber) || mintValueAsNumber <= 0) {
            showNotification('error', "Please enter a valid amount to mint.");
            return;
        }
        if (mintValueAsNumber >= LARGE_AMOUNT && (selectedToken === 'USDC' || selectedToken === 'USDT')) {
            getLocalAndUTCTime();
            setLargeAmountConfirmed(false);
            setLargeAmountValueForModal(mintValueAsNumber);
            setShowTransactionDetailLargeModal(true);
            return;
        }
        setConfirmedAmount(mintValueAsNumber);
        setTxTrigger(prev => prev + 1);
    };

    const handleRedeemUSDi = () => {
        const redeemValueAsNumber = parseFloat(typedMintValue);
        if (isNaN(redeemValueAsNumber) || redeemValueAsNumber <= 0) {
            showNotification('error', "Please enter a valid amount to mint.");
            return;
        }

        if (selectedToken === "CASH") {
            if (!selectedPaymentMethod) {
                setShowAddPayment(true);
                return;
            }

            const matched = availablePaymentMethods.find(
                (m) => m.method_name === selectedPaymentMethod.payment_method
            );

            const limitObj = parseAmountLimit(matched.amount_limit);
            if (limitObj) {
                const {min, max} = limitObj;
                if (limitObj.type === 'range') {
                    if (redeemValueAsNumber < min || redeemValueAsNumber > max) {
                        // TODO below is testing change it back
                        // if (redeemValueAsNumber > max) {
                        showNotification(
                            'warning',
                            `${selectedPaymentMethod.payment_method} requires an amount between $${min.toLocaleString('en-US')} and $${max.toLocaleString('en-US')} USD.`
                        );
                        return;
                    }
                } else if (limitObj.type === 'larger') {
                    if (redeemValueAsNumber < limitObj.min) {
                        showNotification(
                            'warning',
                            `${selectedPaymentMethod.payment_method} requires a minimum amount of $${min.toLocaleString('en-US')} USD.`
                        );
                        return;
                    }
                } else if (limitObj.type === 'less') {
                    if (redeemValueAsNumber > limitObj.max) {
                        showNotification(
                            'warning',
                            `${selectedPaymentMethod.payment_method} requires an amount below $${max.toLocaleString('en-US')} USD.`
                        );
                        return;
                    }
                }
            }

            getLocalAndUTCTime();
            setRedeemValueForModal(redeemValueAsNumber);
            setShowTransactionDetailModal(true);
            return;
        }
        // non-cash redeem
        if (redeemValueAsNumber >= LARGE_AMOUNT && (selectedToken === 'USDC' || selectedToken === 'USDT')) {
            getLocalAndUTCTime();
            setLargeAmountConfirmed(false);
            setLargeAmountValueForModal(redeemValueAsNumber);
            setShowTransactionDetailLargeModal(true);
            return;
        }
        setConfirmedAmount(redeemValueAsNumber);
        setTxTrigger(prev => prev + 1);
    };

    // ------------------------ Show/hide token selector ------------------------
    const handleMethodItemClick = (e) => {
        e.stopPropagation();
        setShowTokenSelector(prev => !prev);
    };

    // ------------------------ COPY FUNCTION ------------------------
    const [justCopied, setJustCopied] = useState(false);

    const handleCopy = (e, address, token) => {
        e.stopPropagation();
        navigator.clipboard.writeText(address).then(() => {
            if (token === "USDC") {
                setJustCopiedUSDC(true);
                setTimeout(() => setJustCopiedUSDC(false), 2000);
            } else if (token === "USDT") {
                setJustCopiedUSDT(true);
                setTimeout(() => setJustCopiedUSDT(false), 2000);
            }
        });
    };
    const handleCopyUSDI = (e) => {
        e.stopPropagation();
        navigator.clipboard.writeText(usdiTokenAddress).then(() => {
            setJustCopied(true);
            setTimeout(() => setJustCopied(false), 2000);
        });
    };

    // ------------------------ SHARE FUNCTION ------------------------
    const handleShare = (e, address) => {
        e.stopPropagation();
        window.open(`https://solscan.io/token/${address}`, "_blank");
    };

    // ------------------------ SELECT TOKEN LOGIC ------------------------
    const handleSelectToken = (token) => {
        if (!justCopiedUSDC && !justCopiedUSDT) {
            setSelectedToken(token);
            setShowTokenSelector(false);
        }
    };

    // ------------------------ "Max" button & validation ------------------------
    const handleSetMax = () => {
        if (selectedTab === 'mint') {
            if (selectedToken === 'USDT') {
                setTypedMintValue(String(usdtBalance));
            } else {
                setTypedMintValue(String(usdcBalance));
            }
        } else if (selectedTab === 'redeem') {
            setTypedMintValue(String(usdiBalance));
        }
    };

    // ------------------------ Handle input changes (decimal limit) ------------------------
    const handleInputChange = (e) => {
        let val = e.target.value;
        val = val.replace(/[^\d.]/g, '');
        if (val === '.0') {
            val = '0.';
        } else if (val.startsWith('.') && val !== '.') {
            val = '0' + val;
        }
        const firstDotIndex = val.indexOf('.');
        if (firstDotIndex !== -1) {
            val = val.slice(0, firstDotIndex + 1) + val.slice(firstDotIndex + 1).replace(/\./g, '');
        }
        const dotIndex = val.indexOf('.');
        if (dotIndex !== -1) {
            const fractional = val.slice(dotIndex + 1, dotIndex + 1 + 6);
            val = val.slice(0, dotIndex + 1) + fractional;
        }
        if (val === '.') {
            setTypedMintValue('0.');
            return;
        }
        if (val.length > 1 && val[0] === '0' && val[1] !== '.') {
            val = val.replace(/^0+/, '');
            if (val === '') {
                val = '0';
            }
        }
        if (!val.endsWith('.')) {
            const digitsWithoutDot = val.replace('.', '');
            if (digitsWithoutDot.length > 16) {
                return;
            }
        }
        setTypedMintValue(val);
    };

    // 打开侧边栏
    const handleConnectWallet = () => {
        setShowPanel(true);
    };

    // 获取本地 & UTC 时间
    function getLocalAndUTCTime() {
        const now = new Date();
        const localYear = now.getFullYear();
        const localMonth = String(now.getMonth() + 1).padStart(2, '0');
        const localDay = String(now.getDate()).padStart(2, '0');
        const localHours = String(now.getHours()).padStart(2, '0');
        const localMinutes = String(now.getMinutes()).padStart(2, '0');
        const localSeconds = String(now.getSeconds()).padStart(2, '0');
        const localTime = `${localMonth}/${localDay}/${localYear}, ${localHours}:${localMinutes}:${localSeconds}`;

        const utcYear = now.getUTCFullYear();
        const utcMonth = String(now.getUTCMonth() + 1).padStart(2, '0');
        const utcDay = String(now.getUTCDate()).padStart(2, '0');
        const utcHours = String(now.getUTCHours()).padStart(2, '0');
        const utcMinutes = String(now.getUTCMinutes()).padStart(2, '0');
        const utcSeconds = String(now.getUTCSeconds()).padStart(2, '0');
        const utcTime = `${utcMonth}/${utcDay}/${utcYear}, ${utcHours}:${utcMinutes}:${utcSeconds}`;

        setLocalTimeTransaction(localTime);
        setUTCTimeTransaction(utcTime);
    }


    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // 若从 mint -> redeem，就 token 变 CASH；反之变 USDC
    useEffect(() => {
        if (selectedTab === "mint") {
            setSelectedToken("USDC");
        } else {
            setSelectedToken("USDC");
        }
    }, [selectedTab]);

    //用来set loading box 状态
    useEffect(() => {
        const lastWallet = localStorage.getItem("lastConnectedWallet")
        if (!lastWallet) {
            setIsWalletLoading(false)
            setHolderDataLoading(false)
        }
    }, []);
    // 动态测量 input 宽度
    useEffect(() => {
        if (!containerRef.current || !spanRef.current || !inputRef.current) return;
        spanRef.current.textContent = typedMintValue === '' ? '0' : typedMintValue;
        spanRef.current.style.fontSize = `${dynamicFontSize}px`;
        spanRef.current.style.fontFamily = getComputedStyle(inputRef.current).fontFamily;
        spanRef.current.style.fontWeight = getComputedStyle(inputRef.current).fontWeight;
        spanRef.current.style.lineHeight = getComputedStyle(inputRef.current).lineHeight;
        spanRef.current.style.letterSpacing = getComputedStyle(inputRef.current).letterSpacing;

        const rect = spanRef.current.getBoundingClientRect();
        spanRef.current.textContent = "USDi";
        const rect_usdi = spanRef.current.getBoundingClientRect();
        const usdi_width = rect_usdi.width;
        // added for comma for 20
        let textWidth
        if (parseFloat(typedMintValue) >= 1000) {
            textWidth = rect.width + 20;
        } else if (parseFloat(typedMintValue) >= 1000000) {
            textWidth = rect.width + 40;
        } else {
            textWidth = rect.width
        }
        const containerWidth = containerRef.current.offsetWidth - usdi_width - 30 - 58 - 40;
        if (textWidth > containerWidth && dynamicFontSize > MIN_FONT_SIZE) {
            const ratio = containerWidth / textWidth;
            let newFont = Math.floor(dynamicFontSize * ratio);
            if (newFont < MIN_FONT_SIZE) newFont = MIN_FONT_SIZE;
            setDynamicFontSize(newFont);
            return;
        }
        if (textWidth < containerWidth * 0.8 && dynamicFontSize < MAX_FONT_SIZE) {
            const newFont = Math.min(MAX_FONT_SIZE, dynamicFontSize + 2);
            setDynamicFontSize(newFont);
            return;
        }
        inputRef.current.style.width = `${textWidth}px`;
    }, [typedMintValue, dynamicFontSize, selectedTab, windowWidth]);

    return (
        <LayoutGroup>
            <div
                className={styles.outerContainer}
                style={{
                    display: "flex",
                    flexDirection: "row",
                    backgroundColor: 'var(--bg-secondary)',
                    height: '100vh',
                    minHeight: '100vh',
                    overflow: 'hidden',
                    width: '100vw'
                }}
            >
                {showTransactionDetailModal && (
                    <TransactionDetailModal
                        fromAmount={redeemValueForModal}
                        fromCurrency="USDi"
                        toCurrency="USD Cash"
                        transactionType="Redeem"
                        network="C2C"
                        networkFeePercent={selectedPaymentMethod.fees}
                        rate="1 USDi = 1 USD"
                        eta={selectedPaymentMethod.processing_time}
                        notes="Note: First, pay the network fee to initiate the transaction. Then, pay the remaining amount upon delivery."
                        localTime={localTimeTransaction}
                        onConfirm={() => {
                            setConfirmedAmount(redeemValueForModal);
                            setTxTrigger(prev => prev + 1);
                            setTypedMintValue("0");
                            // setTransactionDetailConfirmed(true);
                        }}
                        onClose={() => setShowTransactionDetailModal(false)}
                        email={walletUserEmail}
                        walletAddress={walletAddress}
                        confirmed={transactionDetailConfirmed}
                        setConfirmed={setTransactionDetailConfirmed}
                        txsID={transactionDetailTxsID}
                    />
                )}

                {showTransactionDetailLargeModal && (
                    <TransactionDetailLargeAmount
                        fromAmount={largeAmountValueForModal}
                        fromCurrency={selectedTab === 'mint' ? selectedToken : 'USDi'}
                        toCurrency={selectedTab === 'mint' ? 'USDi' : selectedToken}
                        transactionType={selectedTab === 'mint' ? 'Mint' : 'Redeem'}
                        network="Blockchain"
                        networkFeePercent={"0%"}
                        rate={`1 USDi = 1 ${selectedToken}`}
                        eta={"24hrs"}
                        localTime={localTimeTransaction}
                        onConfirm={() => {
                            setConfirmedAmount(largeAmountValueForModal);
                            setTxTrigger(prev => prev + 1);
                            setTypedMintValue("0");
                        }}
                        onClose={() => setShowTransactionDetailLargeModal(false)}
                        email={walletUserEmail}
                        walletAddress={walletAddress}
                        confirmed={largeAmountConfirmed}
                        setConfirmed={setLargeAmountConfirmed}
                    />
                )}

                {/* LEFT PANEL */}
                <LeftPanel walletAddress={walletAddress}/>

                {/* RIGHT PANEL */}
                <div className={styles.rightPanel} style={{display: "flex", flexDirection: "column"}}>
                    <ConnectWalletHeader
                        amount={confirmedAmount}
                        transactionType={selectedTab}
                        transactionTrigger={txTrigger}
                        toAddress={squadsPublicKey}
                        selectedToken={selectedToken}
                        selectedPaymentId={selectedPaymentMethod ? selectedPaymentMethod.payment_info_id : null}
                        selectedPaymentMethod={selectedPaymentMethod ? selectedPaymentMethod : null}
                        onWalletConnected={(publicKey, usdtLeft, usdcLeft, usdiLeft) => {
                            setWalletAddress(publicKey);
                            setUsdtBalance(usdtLeft);
                            setUsdcBalance(usdcLeft);
                            setUsdiBalance(usdiLeft);
                            setAvailableUSDI(usdiLeft);
                            setIsWalletLoading(false);
                        }}
                        transactionTime={UTCTimeTransaction}
                        showPanel={showPanel}
                        setShowPanel={setShowPanel}
                        c2cRedeemTransferComplete={c2cRedeemTransferComplete}
                    />

                    <div className={styles.container}>
                        {/* LEFT – 4 cards stacked vertically, no outer box */}
                        <div className={`${styles.leftContainer} ${styles.leftCardsStack}`}>
                            <MyAssetsCards
                                walletAddress={walletAddress}
                                balance={availableUSDI}
                                usdValue={availableUSDI != null && usdiValue != null ? (availableUSDI * usdiValue) : null}
                                apyLabel={displayedApy}
                                apyValue={ImpliedApy}
                                navPerUsdi={usdiValue}
                                cumulativeInterest={cumulativeInterest}
                                accruedInterest={accruedInterest}
                                isLoading={isWalletLoading}
                                holderDataLoading={holderDataLoading}
                                justCopied={justCopied}
                                onCopy={(e) => handleCopyUSDI(e)}
                                onShare={(address) => handleShare({ stopPropagation: () => {} }, address)}
                                usdiTokenAddress={usdiTokenAddress}
                            />
                        </div>

                        {/* RIGHT */}
                        <div className={styles.rightContainer}>

                            <div className={styles.tabs}>
                                <button
                                    className="relative"
                                    onClick={() => {
                                        if (selectedTab === 'redeem') {
                                            setTypedMintValue("0");
                                        }
                                        setSelectedTab('mint');
                                    }}
                                >
                                    {selectedTab === 'mint' && (
                                        <motion.div
                                            layoutId="active-pill"
                                            className={styles.tapPill}
                                            transition={{type: "spring", duration: 0.6}}
                                        />
                                    )}
                                    <span
                                        className={`${styles.tabText} ${selectedTab !== 'mint' ? styles.nonSelectTabText : ''}`}
                                    >
                                            Mint
                                        </span>
                                </button>
                                <button
                                    className="relative"
                                    onClick={() => {
                                        if (selectedTab === 'mint') {
                                            setTypedMintValue("0");
                                        }
                                        setSelectedTab('redeem');
                                    }}
                                >
                                    {selectedTab === 'redeem' && (
                                        <motion.div
                                            layoutId="active-pill"
                                            className={styles.tapPill}
                                            transition={{type: "spring", duration: 0.6}}
                                        />
                                    )}
                                    <span
                                        className={`${styles.tabText} ${selectedTab !== 'redeem' ? styles.nonSelectTabText : ''}`}
                                    >
                                            Redeem
                                        </span>
                                </button>
                            </div>

                            {/* -------- MINT TAB -------- */}
                            {selectedTab === 'mint' && (
                                <MintTab
                                    // All the props you were using in the inline code:
                                    typedMintValue={typedMintValue}
                                    dynamicFontSize={dynamicFontSize}
                                    containerRef={containerRef}
                                    spanRef={spanRef}
                                    inputRef={inputRef}
                                    handleInputChange={handleInputChange}
                                    handleSetMax={handleSetMax}
                                    usdtBalance={usdtBalance}
                                    usdcBalance={usdcBalance}
                                    usdiBalance={usdiBalance}
                                    selectedToken={selectedToken}
                                    shortenAddress={shortenAddress}
                                    walletAddress={walletAddress}
                                    networkFeePercent={networkFeePercent}
                                    showTokenSelector={showTokenSelector}
                                    methodItemRef={methodItemRef}
                                    handleMethodItemClick={handleMethodItemClick}
                                    tokenSelectorRef={tokenSelectorRef}
                                    handleSelectToken={handleSelectToken}
                                    handleCopy={handleCopy}
                                    justCopiedUSDC={justCopiedUSDC}
                                    justCopiedUSDT={justCopiedUSDT}
                                    handleShare={handleShare}

                                    // Second dropdown + Payment info logic
                                    showTokenSelector3={showTokenSelector3}
                                    methodItemRef3={methodItemRef3}
                                    handleMethodItemClick3={handleMethodItemClick3}
                                    tokenSelectorRef3={tokenSelectorRef3}
                                    paymentInfoData={paymentInfoData}
                                    selectedPaymentMethod={selectedPaymentMethod}
                                    setSelectedPaymentMethod={setSelectedPaymentMethod}
                                    handleSelectPaymentMethod={handleSelectPaymentMethod}
                                    iconMap={iconMap}
                                    getPaymentInfoDisplay={getPaymentInfoDisplay}

                                    walletAddressExists={!!walletAddress}
                                    handleMintUSDi={handleMintUSDi}
                                    handleConnectWallet={handleConnectWallet}

                                    usdcTokenAddress={usdcTokenAddress}
                                    usdtTokenAddress={usdtTokenAddress}

                                    refetchPaymentMethods={refetchPaymentMethods}
                                    setRefetchPaymentMethods={setRefetchPaymentMethods}
                                    showAddPayment={showAddPayment}
                                    setShowAddPayment={setShowAddPayment}
                                    userClass={userClass}
                                    showNotification={showNotification}
                                />
                            )}

                            {/* -------- REDEEM TAB -------- */}
                            {selectedTab === 'redeem' && (
                                <RedeemTab
                                    typedMintValue={typedMintValue}
                                    dynamicFontSize={dynamicFontSize}
                                    containerRef={containerRef}
                                    spanRef={spanRef}
                                    inputRef={inputRef}
                                    handleInputChange={handleInputChange}
                                    handleSetMax={handleSetMax}
                                    usdiBalance={usdiBalance}
                                    usdcBalance={usdcBalance}
                                    usdtBalance={usdtBalance}
                                    selectedToken={selectedToken}
                                    shortenAddress={shortenAddress}
                                    walletAddress={walletAddress}
                                    networkFeePercent={networkFeePercent}
                                    showTokenSelector={showTokenSelector}
                                    methodItemRef={methodItemRef}
                                    handleMethodItemClick={handleMethodItemClick}
                                    tokenSelectorRef={tokenSelectorRef}
                                    handleSelectToken={handleSelectToken}
                                    handleCopy={handleCopy}
                                    justCopiedUSDC={justCopiedUSDC}
                                    justCopiedUSDT={justCopiedUSDT}
                                    handleShare={handleShare}
                                    showTokenSelector3={showTokenSelector3}
                                    methodItemRef3={methodItemRef3}
                                    handleMethodItemClick3={handleMethodItemClick3}
                                    tokenSelectorRef3={tokenSelectorRef3}
                                    paymentInfoData={paymentInfoData}
                                    selectedPaymentMethod={selectedPaymentMethod}
                                    setSelectedPaymentMethod={setSelectedPaymentMethod}
                                    handleSelectPaymentMethod={handleSelectPaymentMethod}
                                    iconMap={iconMap}
                                    getPaymentInfoDisplay={getPaymentInfoDisplay}
                                    walletAddressExists={!!walletAddress}
                                    handleRedeemUSDi={handleRedeemUSDi}
                                    handleConnectWallet={handleConnectWallet}
                                    usdcTokenAddress={usdcTokenAddress}
                                    usdtTokenAddress={usdtTokenAddress}
                                    refetchPaymentMethods={refetchPaymentMethods}
                                    setRefetchPaymentMethods={setRefetchPaymentMethods}
                                    showAddPayment={showAddPayment}
                                    setShowAddPayment={setShowAddPayment}
                                    onAvailableMethodsChange={setAvailablePaymentMethods}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </LayoutGroup>
    );
};

export default SwapMainAPP;
